import { PALETTE } from '../../../../theme/palette';

/**
 * Single product-info style set, matching the storefront's white + orange design.
 */
const STYLES = {
  titleColor: 'text-[#1c1917]',
  descText: 'text-[#78716c]',
  mutedText: 'text-[#a8a29e]',
  sectionTitle: 'text-[#1c1917] font-semibold',
  dividerColor: 'border-[#ededed]',
  iconColor: PALETTE.orange,
  priceColor: PALETTE.orange,

  inputBg: 'bg-white',
  inputBorder: 'border-[#ededed]',
  inputFocusRing: 'focus:ring-[#ff4d00]',
  inputPlaceholder: 'placeholder-[#a8a29e]',

  quantityBorder: 'border-[#ededed]',
  quantityBtn: 'text-[#1c1917] hover:bg-[#f6f6f6]',
  quantityText: 'text-[#1c1917]',

  deliveryBg: 'bg-[#ffe3d6]',
  deliveryIcon: PALETTE.orange,
  deliveryText: 'text-[#7a2c0f]',

  submitBg: PALETTE.orange,
  submitHover: PALETTE.orangeCta,
  submitText: 'text-white',
};

export const useProductInfoStyles = () => STYLES;

export default useProductInfoStyles;
